module.exports = __webpack_public_path__ + "img/yt.63f41dc8.svg";